import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'girls-inc',
    description:
      'Provides metrics related to Girls Inc. Affiliates and associated assessments.',
    icon: 'calculator',
    name: 'Girls Inc.',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
